export default "__VITE_ASSET__BIfZGuhE__"